import { useEffect, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Link } from 'react-router-dom';
import useAlarmsStore, { getMaxSeverity } from 'store/alarms';
import useDevicesStore from 'store/devices';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';
import { ConfigureDeviceModal } from '../manage-devices';
import { getAllChildDevicesByType } from 'util/device';
import { createModal } from '@thermon-platforms/thermon-ui-core';


function LocationTableRow({row}) {
  const [alarmsStore] = useAlarmsStore();
  const [alarms, setAlarms] = useState([]);
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();
  const [detail, setDetail] = useState();

  useEffect(() => {
    setAlarms(alarmsStore.alarms.filter(alarm => {
      if (!alarm.deviceId) return false;
      const path = devicesStore.shallowDevices.get(alarm.deviceId)?.path;
      if (!path) return false;
      return !!path.find(device => device.id == row.id);
    }));
  }, [alarmsStore]);

  function editLocation(location) {
    const editLocationModal = createModal(<ConfigureDeviceModal device={location} />);
    editLocationModal.open()
      .then((res) => {
        // Handle side-effects
        devicesStoreActions.forceUpdate();
      })
      .catch(() => {/* no-op */})
  }

  useEffect(() => {
    devicesStoreActions.fetchDetail(row.id).then((detail) => {
      setDetail(detail);
    });
  }, [row]);

  return (<tr>
    <td>
      <span className={
        `status-icon
        ${alarms.length ? 'attention' : 'ok'}
        ${alarms.length ? getMaxSeverity(alarms) : null}`}></span>
      <Link to={row.id}>{row.name}</Link>
    </td>
    <td>{alarms.length}</td>
    <td>{row.children.length}</td>
    <td>
      {getAllChildDevicesByType(row, 'Panel').length}
    </td>
    <td>
      {usersStoreActions.checkAccess('CanChangeConfiguration', rolesStore.roles) ? <>
        <button
          className="settings"
          onClick={() => editLocation(detail)}
          data-tooltip-content={t`Location Settings`}
          data-tooltip-id="control-tooltip"
        >
          <Trans>Settings</Trans>
        </button>
      </> : <></>}
    </td>
  </tr>);
}

export default LocationTableRow;
